import { Routes } from '@angular/router';
// Third party packages
// Custom packages - Misc
import { RoleGuard } from 'src/app/shared/guards/role.guard';
// Custom packages - Component
import { AddRoleComponent } from 'src/app/modules/roles/pages/add-role/add-role.page';
import { RoleDetailComponent } from 'src/app/modules/roles/pages/role-detail/role-detail.page';
import { RolesListComponent } from 'src/app/modules/roles/pages/roles-list/roles-list.page';
var ɵ0 = {
    permissions: ['canReadRolesList']
}, ɵ1 = {
    permissions: ['canCreateRoles']
}, ɵ2 = {
    permissions: ['canCreateRoles']
};
var routes = [
    {
        path: 'list',
        component: RolesListComponent,
        canActivate: [RoleGuard],
        data: ɵ0,
    },
    {
        path: 'detail/:roleId',
        component: RoleDetailComponent,
        canActivate: [RoleGuard],
        data: ɵ1,
    },
    {
        path: 'add',
        component: AddRoleComponent,
        canActivate: [RoleGuard],
        data: ɵ2,
    },
    {
        path: '**',
        redirectTo: 'it/errors/404'
    }
];
var RolesRoutingModule = /** @class */ (function () {
    function RolesRoutingModule() {
    }
    return RolesRoutingModule;
}());
export { RolesRoutingModule };
export { ɵ0, ɵ1, ɵ2 };
